import { render, staticRenderFns } from "./InvitationsTab.vue?vue&type=template&id=7fd135d8&scoped=true&"
import script from "./InvitationsTab.vue?vue&type=script&lang=js&"
export * from "./InvitationsTab.vue?vue&type=script&lang=js&"
import style0 from "./InvitationsTab.vue?vue&type=style&index=0&id=7fd135d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fd135d8",
  null
  
)

export default component.exports